<template>
  <div class="base-info-container">
    <div class="title">财务应收</div>
    <div class="block">
      <el-table
        :data="financeInInfoTable"
        :show-header="false"
        border
        class="colorful-table"
        :cellStyle="cellStyle"
        size="mini"
      >
        <el-table-column :align="align" prop="key1" width="110"></el-table-column>
        <el-table-column :align="align" prop="val1"></el-table-column>
        <el-table-column :align="align" prop="key2" width="140"></el-table-column>
        <el-table-column :align="align" prop="val2"></el-table-column>
        <el-table-column :align="align" prop="key3" width="120"></el-table-column>
        <el-table-column :align="align" prop="val3"></el-table-column>
      </el-table>
    </div>
    <div class="title">其他收入</div> 
    <div class="block">
      <other-finance-in :data="financeOtherInfos"></other-finance-in>
    </div>
    <div class="title">外发费用</div>
    <div class="block">
        <outgoing-detail :data="WaybillOutgoingFinance"></outgoing-detail>
    </div>
     <div class="title">发车费用</div>
    <div class="block">
        <fa-che-detail :data="WaybillDispatchFinance"></fa-che-detail>
    </div>
    <div class="title">财务应付</div>
    <div class="block">
      <other-finance-out :data="financeOutInfos"></other-finance-out>
    </div>
  </div>
</template>

<script>
import OutgoingDetail from './OutGoingDetail.vue'
import FaCheDetail from './FaCheDetail.vue'
import OtherFinanceIn from './OtherFinanceIn.vue'
import OtherFinanceOut from './OtherFinanceOut.vue'
export default {
  components: {
    OutgoingDetail,
    FaCheDetail,
    OtherFinanceIn,
    OtherFinanceOut
  },
  props: {
    waybillSplitId: {},
  },
  data() {
    return {
      align: "left",
      baseInfo: {},
      goods: [],
      financeInInfo: {},
      financeOutInfos: [],
      financeOtherInfos:[],
      files: [],
      sendAddr: {},
      receiveAddr: {},
      otherInfo: {},
      transportInfo: {},
      showViewer: false,
      previewSrcList: [],
      showItemSpecs: false,
      currentGoods: {
        itemSpecss: [
          {
            wide: 0,
            length: 0,
            height: 0,
          },
        ],
      },
      WaybillOutgoingFinance: [], //外发单单财务信息
      WaybillDispatchFinance:[]
    };
  },
  computed: {
    baseInfoTable() {
      const baseInfo = this.baseInfo;
      const sendAddr = this.sendAddr;
      const receiveAddr = this.receiveAddr;
      const transportInfo = this.transportInfo;
      const otherInfo = this.otherInfo;
      return [
        {
          key1: "运单号",
          val1: baseInfo.waybillNumber,
          key2: "运单状态",
          val2: baseInfo.waybillStatusShow,
          key3: "货物状态",
          val3: baseInfo.goodsStatus,
        },
        {
          key1: "中转单号",
          val1: baseInfo.transferNumber,
          key2: "客户单号",
          val2: baseInfo.customerOrderNumber,
          key3: "业务日期",
          val3: baseInfo.businessDate,
        },
        {
          key1: "开单网点",
          val1: baseInfo.receiveOrderDeptName,
          key2: "目的城市",
          val2: baseInfo.destCity,
          key3: "运输路线",
          val3: baseInfo.transportLineName,
        },
        {
          key1: "终端网点",
          val1: baseInfo.endDeptName,
          key2: "发货方式",
          val2: baseInfo.receiveMethod,
          key3: "运输方式",
          val3: baseInfo.transportMethod,
        },
        {
          key1: "交货方式",
          val1: baseInfo.sendMethod,
          key2: "回单要求",
          val2: baseInfo.rnRequireName,
          key3: "回单份数",
          val3: baseInfo.rnRequireCount,
        },
        {
          key1: "订单指令号",
          val1: baseInfo.commandNumber,
          key2: "开单备注",
          val2: baseInfo.remarks,
          ignoreCells: [4],
        },
        {
          key1: "客户类型",
          val1: baseInfo.customerTypeShow,
          key2: "开单客户",
          val2: baseInfo.customerName,
          ignoreCells: [4],
          // key2: "发货人",
          // val2: sendAddr.contacts,
          // key3: "发货单位",
          // val3: sendAddr.company,
        },
        // {
        //   key1: "发货联系电话",
        //   val1: sendAddr.phone,
        //   key2: "发货人身份证号码",
        //   val2: sendAddr.idNumber,
        //   key3: "发货地址",
        //   val3: sendAddr.address,
        // },
        // {
        //   key1: "收货人",
        //   val1: receiveAddr.contacts,
        //   key2: "收货单位",
        //   val2: receiveAddr.company,
        //   key3: "收货联系电话",
        //   val3: receiveAddr.phone,
        // },
        // {
        //   key1: "收货人身份证号码",
        //   val1: receiveAddr.idNumber,
        //   key2: "收货地址",
        //   val2: receiveAddr.address,
        //   key3: "",
        //   val3: "",
        //   ignoreCells: [4],
        // },
        {
          key1: "预计提货时间",
          val1: transportInfo.takeTime,
          key2: "预计送货时间",
          val2: transportInfo.deliveryTime,
          key3: "是否进仓",
          val3: transportInfo.isIntoStorageShow,
        },
        {
          key1: "进仓号",
          val1: transportInfo.intoStorageNumber,
          key2: "收货仓号",
          val2: transportInfo.receiveStorageNumber,
          key3: "特殊要求",
          val3: transportInfo.specialRequire,
        },
        {
          key1: "是否加急",
          val1: transportInfo.isUrgentShow,
          key2: "是否等通知放货",
          val2: transportInfo.isWaitNoticeSendShow,
          key3: "是否贵重",
          val3: transportInfo.isValuableShow,
        },
        {
          key1: "业务员",
          val1: otherInfo.businessName,
          key2: "业务员提成（%）",
          val2: otherInfo.businessCostRate,
          key3: "跟单员",
          val3: otherInfo.merchandiserEmployeeName,
        },
        {
          key1: "装卸员",
          val1: otherInfo.handlingEmployeeName,
          key2: "录单员",
          val2: otherInfo.createUserName,
          key3: "录单时间",
          val3: otherInfo.createTime,
        },
        {
          key1: "签收人",
          val1: baseInfo.signForUserName,
          key2: "签收时间",
          val2: baseInfo.signForTime,
          key3: "签收经办人",
          val3: baseInfo.signForName,
        },
        {
          key1: "运单审核状态",
          val1: baseInfo.examineStatusShow,
          key2: "",
          val2: "",
          key3: "",
          val3: "",
          ignoreCells: [2],
        },
      ];
    },
    financeInInfoTable() {
      const financeInInfo = this.financeInInfo;
      return [
        {
          key1: "计费方式",
          val1: financeInInfo.formulaBillingWeightName,
          key2: "单价",
          val2: financeInInfo.unitPrice,
          key3: "基本运费",
          val3: financeInInfo.basicFreight,
        },
        {
          key1: "提货费",
          val1: financeInInfo.takeFee,
          key2: "送货费",
          val2: financeInInfo.sendFee,
          key3: "中转费",
          val3: financeInInfo.transferFee,
        },
        {
          key1: "代收货款",
          val1: financeInInfo.agentAmount,
          key2: "代收货款费率(‰)",
          val2: financeInInfo.agentServiceRate,
          key3: "代收货款手续费",
          val3: financeInInfo.agentServiceFee,
        },
        {
          key1: "声明价值",
          val1: financeInInfo.declaredValue,
          key2: "保险费费率（‰）",
          val2: financeInInfo.declaredValueRate,
          key3: "保险费",
          val3: financeInInfo.insuranceFee,
        },
        {
          key1: "其他费用",
          val1: financeInInfo.allOtherFee,
          key2: "服务费",
          val2: financeInInfo.serviceFee,
          key3: "运费合计",
          val3: financeInInfo.totalFreight,
        },
        {
          key1: "运单结算方式",
          val1: financeInInfo.settlementMethod,
          key2: "现付金额",
          val2: financeInInfo.senderAmount,
          key3: "到付金额",
          val3: financeInInfo.receivedAmount,
        },
        {
          key1: "月结金额",
          val1: financeInInfo.monthlyAmount,
          key2: "回单付金额",
          val2: financeInInfo.rnorderAmount,
          key3: "货款扣运费",
          val3: financeInInfo.goodsDeductedAmoun,
        },
        {
          key1: "是否开票",
          val1: financeInInfo.isInvoice,
          key2: "到付结算方式",
          val2: financeInInfo.isInvoiceShow,
          key3: "财务备注",
          val3: financeInInfo.financeRemarks,
        },
      ];
    },
    SendAddrInfo(){
      const sendAddr = this.sendAddr;
      return [
        {
          key1: "发货单位",
          val1: sendAddr.company,
          key2: "联系人",
          val2: sendAddr.contacts,
          key3: "联系电话",
          val3: sendAddr.phone,
          ignoreCells: [6]
        },
        {
          key1: "省份",
          val1: sendAddr.provinceName,
          key2: "城市",
          val2: sendAddr.cityName,
          key3: "区县",
          val3: sendAddr.areaName,
          key4: "详细地址",
          val4: sendAddr.address,
        },
      ]
    },
    ReceAddrInfo(){
      const receiveAddr = this.receiveAddr;
      return [
        {
          key1: "收货单位",
          val1: receiveAddr.company,
          key2: "联系人",
          val2: receiveAddr.contacts,
          key3: "联系电话",
          val3: receiveAddr.phone,
          ignoreCells: [6]
        },
        {
          key1: "省份",
          val1: receiveAddr.provinceName,
          key2: "城市",
          val2: receiveAddr.cityName,
          key3: "区县",
          val3: receiveAddr.areaName,
          key4: "详细地址",
          val4: receiveAddr.address,
        },
      ]
    },
  },
  watch: {
    waybillSplitId: {
      handler(val) {
        if (!val) {
          this.baseInfo = {};
          this.goods = [];
          this.financeInInfo = {};
        }
        this.getDetail();
      },
    },
  },
  mounted(){
    this.getDetail()
  },
  methods: {
    cellStyle({ row, columnIndex }) {
      const ignoreCells = row.ignoreCells;
      if (ignoreCells && ignoreCells.includes(columnIndex)) {
        return {
          background: "none",
        };
      }
    },
    async getDetail() {
      if(!this.waybillSplitId){
        return;
      }
      const res = await this.$API.getWaybillDetail(this.waybillSplitId);
      this.baseInfo = res.baseInfo;
      if (res.sendAddrs) {
        this.goods = res.sendAddrs[0].items;
        this.sendAddr = res.sendAddrs[0] || {};
      }
      if (res.receiveAddr) {
        this.receiveAddr = res.receiveAddr || {};
      }
      this.financeInInfo = res.financeInInfo || {};
      this.financeOutInfos = res.financeOutInfos || [];
      this.financeOtherInfos = res.financeOtherInfos || []
      this.files = res.files || [];
      this.otherInfo = res.otherInfo || {};
      this.transportInfo = res.transportInfo;
      this.getWaybillOutgoingFinance()
      this.getWaybillDispatchFinance()
    },
    getWaybillOutgoingFinance() {
      this.$API
        .getWaybillOutgoingFinance({
          waybillSplitId: this.waybillSplitId,
        })
        .then((res) => {
          let datas = res.data.result || [];
          this.WaybillOutgoingFinance = datas || [];
        });
    },
    getWaybillDispatchFinance() {
      this.$API
        .getWaybillDispatchFinance({
          waybillSplitId: this.waybillSplitId,
        })
        .then((res) => {
          let datas = res.data.result || "";
          this.WaybillDispatchFinance = datas.financeOutVos || [];
        });
    },
    checkAttach(row) {
      this.previewSrcList = row.files.map((item) => item.fileUrl);
      this.showViewer = true;
    },
    viewItemSpes(goods) {
      this.currentGoods = goods;
      this.showItemSpecs = true;
    },
  },
};
</script>

<style scoped lang="less">
.base-info-container {
  padding-bottom: 10px;
  .title {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: #0000ff;
    border-bottom: 1px solid #d7d7d7;
    padding-left: 10px;
  }
  .block {
    margin: 10px 0 0 0;
    .colorful-table {
      /deep/ .el-table__cell:nth-child(odd) {
        background: #f9fafc;
      }
    }
  }
}
</style>